import './BookCard.scss'

import { useState } from 'react'

import {
  Button,
  Modal,
  Space,
  Typography
} from 'antd'
import { DATE_FORMAT } from 'configs/constant'
import { PDF_VIEW } from 'configs/path'
import dayjs from 'dayjs'
import { useAppSelector } from 'hooks'
import { IBook } from 'models/book'
import { useTranslation } from 'react-i18next'
import {
  Link,
  useSearchParams
} from 'react-router-dom'
import { bindParams } from 'utilities/helpers'

interface BookCardProps {
  id: number | string
  pdf: IBook
}

const BookCard: React.FC<BookCardProps> = ({ pdf }) => {
  const [openModal, setOpenModal] = useState(false)
  const { t } = useTranslation()
  const app = useAppSelector((s) => s.app.app_id)
  const [query] = useSearchParams()

  return (
    <>
      <div className="book-card-item" onClick={() => setOpenModal(true)}>
        <img src={pdf.thumbnail_url} className="book-image" />
        <Typography className="book-title">
          {!!pdf.is_new && <span></span>}
          {pdf.name}
        </Typography>
      </div>
      <Modal
        className="book-modal-detail modal-common"
        title={pdf.name}
        centered
        open={openModal}
        width={945}
        footer={
          <Link
            to={{
              pathname: bindParams(PDF_VIEW, {
                app: app
              }),
              search: `magazineId=${pdf.id}&isPurchase=${pdf.is_purchased}${
                query.get('typeSearch') == '1' ? `&keyword=${encodeURIComponent(query.get('keyword') || '')}` : ''
              }`
            }}
            target="_blank"
            className="browse"
          >
            <Button type="primary" className="btn-primary">
              {t('browse')}
            </Button>
          </Link>
        }
        onCancel={() => setOpenModal(false)}
      >
        <div className="modal-content">
          <img src={pdf.thumbnail_url} alt="thumbnail" />
          <p>{pdf.description}</p>
        </div>
        {(pdf.publish_at || pdf.distribution_start_at) && (
          <Space className="publish">
            <p>{t('release_date')}</p>
            <p style={{ marginLeft: '3rem' }}>
              {pdf.publish_at ? dayjs(pdf.publish_at).format(DATE_FORMAT) : dayjs(pdf.distribution_start_at).format(DATE_FORMAT)}
            </p>
          </Space>
        )}
      </Modal>
    </>
  )
}

export default BookCard
